import {
  ApiResponse,
  MiddleMileDownloadResponse,
  MiddleMileUIResponse,
} from "../../models/ApiResponse";
import { UpdateMiddleMileRequest } from "../../models/requestModels/updateMiddleMileRequest";
import { MiddleMileResponse } from "../../models/responseModels/middleMileResponse";
import { axiosRequests } from "../axiosRequest";

export const MiddleMileAgent = {
  getMiddleMileList: () =>
    axiosRequests.get<MiddleMileUIResponse>("/middleMile/GetMiddleMileList"),
  middleMileCsvDownload: (middleMileData: MiddleMileResponse[]) =>
    axiosRequests.post<MiddleMileDownloadResponse>(
      "/middleMile/DownloadCsv",
      middleMileData
    ),
  middleMileXlsxDownload: (middleMileData: MiddleMileResponse[]) =>
    axiosRequests.postXlsx<Blob>("/middleMile/DownloadXlsx", middleMileData),
  updateMiddleMile: (middleMileData: UpdateMiddleMileRequest) =>
    axiosRequests.post<ApiResponse>(
      "/middleMile/updateMiddleMile",
      middleMileData
    ),
};
